import PropTypes from 'prop-types';

import exploitationProp from 'components/propTypes/exploitation';

export default PropTypes.shape({
  exploitations: PropTypes.arrayOf(exploitationProp),
  id: PropTypes.number,
  name: PropTypes.string,
});
